import { IconProps } from "./type";

const ChangePasswordIcon = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.7144 13.9761C0.8944 15.3121 2.0008 16.3593 3.348 16.4209C4.4808 16.4729 5.632 16.5001 6.9 16.5001C8.168 16.5001 9.3192 16.4729 10.452 16.4201C11.7992 16.3593 12.9056 15.3121 13.0856 13.9761C13.2032 13.1041 13.3 12.2105 13.3 11.3001C13.3 10.3897 13.2032 9.49614 13.0856 8.62414C12.9056 7.28814 11.7992 6.24094 10.452 6.17934C9.26878 6.12527 8.08446 6.09886 6.9 6.10014C5.632 6.10014 4.4808 6.12734 3.348 6.18014C2.0008 6.24094 0.8944 7.28814 0.7144 8.62414C0.596 9.49614 0.5 10.3897 0.5 11.3001C0.5 12.2105 0.5968 13.1041 0.7144 13.9761Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.30078 6.1V4.1C3.30078 3.14522 3.68007 2.22955 4.3552 1.55442C5.03033 0.879285 5.946 0.5 6.90078 0.5C7.85556 0.5 8.77123 0.879285 9.44636 1.55442C10.1215 2.22955 10.5008 3.14522 10.5008 4.1V6.1M7.00078 11.3H6.90078M3.80078 11.3H3.70078M10.2008 11.3H10.1008M7.10078 11.3C7.10078 11.353 7.07971 11.4039 7.0422 11.4414C7.0047 11.4789 6.95382 11.5 6.90078 11.5C6.84774 11.5 6.79687 11.4789 6.75936 11.4414C6.72185 11.4039 6.70078 11.353 6.70078 11.3C6.70078 11.247 6.72185 11.1961 6.75936 11.1586C6.79687 11.1211 6.84774 11.1 6.90078 11.1C6.95382 11.1 7.0047 11.1211 7.0422 11.1586C7.07971 11.1961 7.10078 11.247 7.10078 11.3ZM3.90078 11.3C3.90078 11.353 3.87971 11.4039 3.8422 11.4414C3.8047 11.4789 3.75382 11.5 3.70078 11.5C3.64774 11.5 3.59687 11.4789 3.55936 11.4414C3.52185 11.4039 3.50078 11.353 3.50078 11.3C3.50078 11.247 3.52185 11.1961 3.55936 11.1586C3.59687 11.1211 3.64774 11.1 3.70078 11.1C3.75382 11.1 3.8047 11.1211 3.8422 11.1586C3.87971 11.1961 3.90078 11.247 3.90078 11.3ZM10.3008 11.3C10.3008 11.353 10.2797 11.4039 10.2422 11.4414C10.2047 11.4789 10.1538 11.5 10.1008 11.5C10.0477 11.5 9.99687 11.4789 9.95936 11.4414C9.92185 11.4039 9.90078 11.353 9.90078 11.3C9.90078 11.247 9.92185 11.1961 9.95936 11.1586C9.99687 11.1211 10.0477 11.1 10.1008 11.1C10.1538 11.1 10.2047 11.1211 10.2422 11.1586C10.2797 11.1961 10.3008 11.247 10.3008 11.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChangePasswordIcon;
